var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"cursor":"pointer"}},[_c('input',{attrs:{"name":_vm.name,"type":_vm.type},domProps:{"value":_vm.value,"checked":_vm.checked}}),_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }